import { getEnv } from "@/utils";
import APIAbstract from "./apiAbstract";
import { AxiosResponse } from "axios";
import { Profile } from "vue";

export default class BiolockApi extends APIAbstract {
  constructor() {
    super({
      baseUrl: `${getEnv("oidcAuthAuthority", "notSet")}`,
      basePath: "biolock",
    });
  }

  get endpoint(): string {
    return this.options.basePath;
  }

  public updateBiolock(
    activated: boolean,
    photo: Blob | undefined
  ): Promise<AxiosResponse> {
    const data = new FormData();
    data.append("activated", activated ? "true" : "false");
    if (photo) {
      data.append("photo", photo, "photo.jpeg");
    }
    return this.client
      .post(`${this.endpoint}`, data, {
        headers: { "content-type": "multipart/form-data" },
      })
      .then((response) => {
        return Promise.resolve(response);
      });
  }
}
